const tableWrap = () => {
    const tables = document.querySelectorAll('table');
    if (tables.length === 0) return;
    tables.forEach((table) => {
        const tableWrap = document.createElement('div');
        tableWrap.classList.add('table-wrap');
        table.parentNode.insertBefore(tableWrap, table);
        tableWrap.appendChild(table);
    });
};

const main = () => {
    if (document.querySelector('#page-campaign-events') === null) return;
    tableWrap();
};

export default main;
